export default __webpack_public_path__ + "static/media/04.47df360f.jpg";